export default class DeductService {
  private balance = 0;
  private interestTotal = 0;
  private fineTotal = 0;

  constructor(balance: number, interestTotal: number, fineTotal: number) {
    this.setStates(balance, interestTotal, fineTotal);
  }

  public setStates(balance: number, interestTotal: number, fineTotal: number) {
    this.balance = balance;
    this.interestTotal = interestTotal;
    this.fineTotal = fineTotal;
  }

  public payment(payment: number, isDeductInterestFirst: boolean) {
    let remaining = payment;

    if (isDeductInterestFirst) {
      if (this.interestTotal > 0 && remaining > 0) {
        const valuePaidInterest = Math.min(this.interestTotal, remaining);
        this.interestTotal -= valuePaidInterest;
        remaining -= valuePaidInterest;
      }

      if (this.fineTotal > 0 && remaining > 0) {
        const valuePaidFine = Math.min(this.fineTotal, remaining);
        this.fineTotal -= valuePaidFine;
        remaining -= valuePaidFine;
      }
    } else {
      if (this.balance > 0 && remaining > 0) {
        const valuePaidBalance = Math.min(this.balance, remaining);
        this.balance -= valuePaidBalance;
        remaining -= valuePaidBalance;
      }

      if (this.interestTotal > 0 && remaining > 0) {
        const valuePaidFine = Math.min(this.interestTotal, remaining);
        this.interestTotal -= valuePaidFine;
        remaining -= valuePaidFine;
      }

      if (this.fineTotal > 0 && remaining > 0) {
        const valuePaidFine = Math.min(this.fineTotal, remaining);
        this.fineTotal -= valuePaidFine;
        remaining -= valuePaidFine;
      }
    }

    this.balance -= remaining;

    return { balance: this.balance, fineTotal: this.fineTotal, interestTotal: this.interestTotal };
  }

  public installment(payment: number, isDeductInterestFirst: boolean) {
    console.info(`deduct_interest_first = ${isDeductInterestFirst}`);
    let remaining = payment;

    if (isDeductInterestFirst) {
      // Cenário 1: Juros -> Multa -> Principal
      if (this.interestTotal < 0 && remaining > 0) {
        const valuePaidInterest = Math.min(-this.interestTotal, remaining);
        this.interestTotal += valuePaidInterest;
        remaining -= valuePaidInterest;
      }
      if (this.fineTotal < 0 && remaining > 0) {
        const valuePaidFine = Math.min(-this.fineTotal, remaining);
        this.fineTotal += valuePaidFine;
        remaining -= valuePaidFine;
      }
      if (this.balance < 0 && remaining > 0) {
        const valuePaidBalance = Math.min(-this.balance, remaining);
        this.balance += valuePaidBalance;
        remaining -= valuePaidBalance;
      }
    } else {
      // Cenário 2: Principal -> Juros -> Multa
      if (this.balance < 0 && remaining > 0) {
        const valuePaidBalance = Math.min(-this.balance, remaining);
        this.balance += valuePaidBalance;
        remaining -= valuePaidBalance;
      }
      if (this.interestTotal < 0 && remaining > 0) {
        const valuePaidInterest = Math.min(-this.interestTotal, remaining);
        this.interestTotal += valuePaidInterest;
        remaining -= valuePaidInterest;
      }
      if (this.fineTotal < 0 && remaining > 0) {
        const valuePaidFine = Math.min(-this.fineTotal, remaining);
        this.fineTotal += valuePaidFine;
        remaining -= valuePaidFine;
      }
    }

    this.balance += remaining;

    return { balance: this.balance, fineTotal: this.fineTotal, interestTotal: this.interestTotal };
  }
}
